import React from 'react';
import { AvailabilityTypes } from 'sarsaparilla';

const AvailablilityLegend = () => {
  return (
    <AvailabilityTypes
      legendItems={{
        available: false,
        availableNumber: true,
        walkup: true,
        lottery: false,
        unavailable: true
      }} />
  );
};

export default AvailablilityLegend;
